export default "__VITE_ASSET__C8ql6Vuc__"